<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏 -->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>
                        类型：
                        <el-radio-group v-model="searchVal.allotType" @change="searchDo">
                            <el-radio-button label="ALL">全部</el-radio-button>
                            <el-radio-button label="0">出库</el-radio-button>
                            <el-radio-button label="1">入库</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div style="margin-left: 15px;"> <!-- fill="#EBB563"  -->
                        状态：
                        <el-radio-group v-model="searchVal.allotStatus" @change="searchDo">
                            <el-radio-button label="ALL">全部</el-radio-button>
                            <el-radio-button label="1">途中</el-radio-button>
                            <el-radio-button label="2">签收</el-radio-button>
                            <el-radio-button label="3">拒收</el-radio-button>
                        </el-radio-group>
                    </div>
                    <!--
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                    -->
                </div>
                <div>
                    <el-button v-if="this.$store.state.currentHr.agentLevel===0" type="success" icon="el-icon-truck" @click="viewAdd()">调拨</el-button>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV">
                        <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true"></i>
                    </el-button>
                </div>
            </div>
            <div v-show="showFV" >

                <div style="margin-top: 15px;">
                    条件：
                    <el-input size="mini" placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                        <el-select size="mini" v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                            <el-option v-for="item in keywordList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-input>
                </div>
            </div>
        </div>

        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :cell-style="columnbackgroundStyle"
                    :data="devAllotOrders"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    @selection-change="handleSelectionChange"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%">
                <el-table-column type="expand" label="">
                    <template slot-scope="props">
                        <div style="padding: 30px 0 30px 50px; width: 500px;">
                            <el-descriptions class="margin-top" title="" :column="1" size="mini" border>
                                <template slot="extra">
                                </template>
                                <el-descriptions-item label="调拨单号">{{ props.row.allotBatNo }}</el-descriptions-item>
                                <el-descriptions-item label="调出方">{{ props.row.outAgentName }}</el-descriptions-item>
                                <el-descriptions-item label="调出方ID">{{ props.row.outAgentId }}</el-descriptions-item>
                                <el-descriptions-item label="调出处理人员">{{ props.row.outAgentPerson }}</el-descriptions-item>
                                <el-descriptions-item label="接收方">{{ props.row.inAgentName }}</el-descriptions-item>
                                <el-descriptions-item label="接收方ID">{{ props.row.inAgentId }}</el-descriptions-item>
                                <el-descriptions-item label="确认处理人员">{{ props.row.inAgentPerson }}</el-descriptions-item>
                                <el-descriptions-item label="快递公司">{{ props.row.expressComp }}</el-descriptions-item>
                                <el-descriptions-item label="快递单号">{{ props.row.expressNo }}</el-descriptions-item>
                            </el-descriptions>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column type="selection" align="center" />
                <el-table-column label="类型" width="80" align="center"  >
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.type=='0'" color="#FFFFFF">出库</el-tag>
                        <el-tag type="success" v-else color="#FFFFFF">入库</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="allotBatNo" label="调拨单号" width="140" align="center"  />
                <el-table-column prop="outAgentName" label="调出方" width="110" show-overflow-tooltip />
                <el-table-column prop="inAgentName" label="接收方" width="110" show-overflow-tooltip />
                <el-table-column prop="orderAmount"
                                 label="订单金额" width="100" align="right">
                    <template slot-scope="scope">
                        {{Number(scope.row.orderAmount).toLocaleString('zh-CN', { minimumFractionDigits: 2 })}}
                    </template>
                </el-table-column>

                <el-table-column prop="status" label="状态" width="70" align="center">
                    <template slot-scope="scope">
                        <el-tag effect="dark" :type="scope.row.status===1?'danger':scope.row.status===2?'success':'waring'">
                            {{_enums.DevAllotStatusEnum.getNameById(scope.row.status)}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="费用标志" width="80" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.orderPayFlag===1">-</span>
                        <el-tag v-else effect="dark"
                                :type="scope.row.orderPayFlag===2?'danger':scope.row.orderPayFlag===3?'success':scope.row.orderPayFlag===4?'info':'warning'">
                            {{_enums.DevAllotPayFlagEnum.getNameById(scope.row.orderPayFlag)}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="devAllotTotals" label="设备数量" width="150">
                    <template slot-scope="scope">
                        <div v-for="(item, index) in scope.row.devAllotTotals">
                            {{item.model}} <u style="color: blue;font-weight: bolder">{{item.cnt}}</u> 台
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="outDateTime" label="调出时间" width="150" align="center" sortable/>
                <el-table-column prop="inDateTime" label="确认时间" width="150" align="center" sortable />
                <!--
                <el-table-column prop="outAgentPerson" label="调出处理人员" width="100" show-overflow-tooltip />
                <el-table-column prop="inAgentPerson" label="确认处理人员" width="100" show-overflow-tooltip />
                <el-table-column prop="expressComp" label="快递公司" width="100" />
                <el-table-column prop="expressNo" label="快递单号" width="150" />
                -->
                <el-table-column fixed="right" label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <div class="yx-flex-h-center" >
                            <el-button type="text"  size="mini" @click="viewDetail(scope.row)">详情</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div class="yx-flex-v">
            </div>
            <el-pagination
                    background
                    :current-page.sync="page"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="slot, sizes, prev, pager, next, jumper, total"
                    :pager-count="5"
                    :total="total">
            </el-pagination>
        </div>

        <el-dialog
                :title="titleDlg"
                :visible.sync="showDlg"
                :lock-scroll="false"
                :append-to-body="true"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                width="60%"
                class="dlg-normal">
            <div style="height: 380px; margin-top: 5px; overflow-y: auto;">
                <el-form :model="insDevAllotOrderForm" :rules="rules" ref="insDevAllotOrderForm">
                    <div class="form-s">
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="调拨单号" prop="allotBatNo">
                                    <el-input size="small" v-model="insDevAllotOrderForm.allotBatNo" :disabled="true" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="接收单位" prop="inAgentId">
                                    <el-select v-model="insDevAllotOrderForm.inAgentId" placeholder="接收单位" size="small" filterable @change="getAgentName2"
                                               style="width: 100%;">
                                        <el-option
                                                v-for="item in arch_allAgentIdNameWithOutThis"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <!--
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="服务商代码" prop="inAgentCode">
                                    <el-input size="small" v-model="insDevAllotOrderForm.inAgentCode" :disabled="true" @blur.prevent="getAgentName()"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="服务商名称" prop="inAgentName">
                                    <el-input size="small" v-model="insDevAllotOrderForm.inAgentName"  :disabled="true" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        -->
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="物流公司" prop="expressComp">
                                    <el-input size="small" v-model="insDevAllotOrderForm.expressComp" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="物流单号" prop="expressNo">
                                    <el-input size="small" v-model="insDevAllotOrderForm.expressNo" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="this.$store.state.currentHr.agentLevel===0">
                            <div class="yx-flex-h-start">
                                <el-form-item label="设备单价" prop="price">
                                    <el-input-number v-model="insDevAllotOrderForm.price" :min="0" :max="1000" label="单价"></el-input-number>
                                </el-form-item>
                                <el-form-item  style="margin-left: 20px;">
                                    <span>订单金额： {{amount}} 元</span>
                                </el-form-item>
                            </div>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="设备序号" prop="termSnTxt">
                                    <el-input type="textarea" :rows="8" size="small" v-model="insDevAllotOrderForm.termSnTxt"  placeholder="终端SN，换行 或 “-”批量录入号段，例如001-005"  />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="yx-flex-h-between">
                    <div class="yx-flex-v">
                        <el-tag type="info" style="margin-left: 10px">
                            <i class="header-icon el-icon-info"></i>
                            小计：&nbsp;&nbsp;
                            {{devCnt}}&nbsp;&nbsp;台
                        </el-tag>
                    </div>
                    <div>
                        <!--
                        <el-button style="margin-right: 100px;" size="small" type="warning" @click="dlgCommit">清空待调拨设备列表</el-button>
                        -->
                        <el-button size="small" @click="showDlg = false">取 消</el-button>
                        <el-button size="small" type="primary" @click="dlgCommit">确 定</el-button>
                    </div>
                </div>

            </span>
        </el-dialog>



        <el-drawer
                class="drw"
                :with-header=false
                :visible.sync="drawer"
                :show-close=false
                size = "50%"
                direction="rtl">
            <DevAllotDetailDiv :key="drawerKey" @onDataLoadFinishPay="onDataLoadFinishPay" @onDataLoadSnTexts="onDataLoadSnTexts" v-bind:inDevAllotOrder="devAllotOrder" v-bind:outDrawerClose.sync="drawerRe"></DevAllotDetailDiv>
        </el-drawer>

    </div>

</template>

<script>

    import {
        URL_AGENT_FROMS,
        URL_AGENT_NAME,
        URL_DATA_ALLOTORDERNO
    } from "../../utils/cons";
    import AreaSelect from "../../components/pub/AreaSelect";
    import DevAllotDetailDiv from "../../components/dev/DevAllotDetailDiv";
    import {deepClone, findIdxByKeyValue} from "../../utils/datatool";

export default {
        name: "DevAllot",
    components: {DevAllotDetailDiv, AreaSelect},
    data() {
            return {
                drawerKey: Date.now(),
                drawer: false,
                drawerRe: false,
                disableBtn: true,
                allotStatusList:[{'id':2,'name':'接收入库'},{'id':3,'name':'拒收'}],
                title: '',
                showFV: false,
                loading: false,
                total: 0,
                totalTxt:'',
                page: 1,
                size: 10,
                titleDlg: '',
                showDlg: false,
                devAllotOrders: [],
                devAllotOrder:{},
                keywordList: [
                    {id:"outAgentName",name:"调出服务商"},
                    {id:"inAgentName",name:"接收服务商"},
                ],
                searchVal: {
                    allotType: 'ALL',
                    allotStatus: 'ALL',
                    keywordMethod: '',
                    keyword: '',
                },
                devCnt: 0,
                devObj: {total:0,tsnLst:null},
                devAllotDetail: {
                    terSn: null
                },
                initDevAllotOrderForm: {
                    allotBatNo: null,
                    inAgentCode: null,
                    inAgentId : null,
                    inAgentName: null,
                    expressComp: null,
                    expressNo: null,
                    termSnTxt: null,
                    devAllotDetails: []
                },
                arch_allAgentIdNameWithOutThis: null,
                insDevAllotOrderForm: {
                    price: 2,
                    allotBatNo: null,
                    inAgentCode: null,
                    inAgentId : null,
                    inAgentName: null,
                    expressComp: null,
                    expressNo: null,
                    termSnTxt: null,
                    devAllotDetails: []
                },
                rules: {
                    inAgentId: [{required: true, message: '请选择接收单位', trigger: 'blur'}],
                    allotBatNo: [{required: true, message: 'allotBatNo', trigger: 'blur'}],
                    price: [{required: true, message: 'price', trigger: 'blur'}],
                    termSnTxt: [{required: true, message: '请输入设备序列号', trigger: 'blur'}],
                    expressComp: [{required: true, message: '请输入物流公司', trigger: 'blur'}],
                    expressNo: [{required: true, message: '请输入物流单号', trigger: 'blur'}],
                }
            }
        },
        watch:{
            drawer: {
                handler:function(val) {
                    if(this.drawer===true) {
                        this.drawerRe = true;
                    }
                }
            },
            drawerRe: {
                handler:function(val) {
                    if(this.drawerRe===false) {
                        this.initDevAllotOrders();
                    }
                }
            },
            insDevAllotOrderForm: {
                handler:function(val) {
                    if(this.insDevAllotOrderForm.termSnTxt && this.insDevAllotOrderForm.termSnTxt.length>0) {
                        this.devObj = this._StringUtils.batTermSn(this.insDevAllotOrderForm.termSnTxt);
                        if(this.devObj) {
                            this.devCnt = this.devObj.total;
                        }
                        else {
                            this.devCnt = 'x--x--x 格式错 x--x--x';
                        }
                    }
                },
                deep:true
            }
        },
        computed: {
            amount() {
                return this.devCnt*this.insDevAllotOrderForm.price;
            }
        },
        mounted() {
            this.initDevAllotOrders();
        },
        methods: {
            // 改变Table某一列的背景颜色
            // columnIndex为列下标
            columnbackgroundStyle({ row, column, rowIndex, columnIndex }) {
                if (column.label == '操作') {
                    //让下标为1的列数背景颜色显示为红色（颜色自定义根据大家需求来）
                    return 'background:#fafafa;'
                }
            },
            onDataLoadFinishPay(allotBatNo) {
                console.log("allotBatNo", allotBatNo)
                this.drawer = false
                this.initDevAllotOrders();
            },
            onDataLoadSnTexts(snTexts) {
                this.drawer = false
                this.viewAdd(snTexts)
            },
            viewDetail(data) {
                Object.assign(this.devAllotOrder, data);
                this.drawerKey = Date.now()
                this.drawer = true;
            },
            searchReset() {
                this.searchVal = {};
            },
            searchDo() {
                this.page = 1;
                this.initDevAllotOrders();
            },
            initDevAllotOrders() {
                this.loading = true;
                let urlParam = '?page=' + this.page + '&size=' + this.size;

                if (this.searchVal.allotType && this.searchVal.allotType!="ALL") {
                    urlParam += '&type=' + this.searchVal.allotType;
                }
                if (this.searchVal.allotStatus && this.searchVal.allotStatus!="ALL") {
                    urlParam += '&status=' + this.searchVal.allotStatus;
                }
                if (this.searchVal.keywordMethod && this.searchVal.keyword)
                    urlParam += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;

                this.getRequest("/dev/devAllotOrder" + urlParam).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.devAllotOrders = resp.data;
                        this.total = resp.total;
                    }
                });

                // 全部服务商ID列表
                this.getRequest(URL_AGENT_FROMS + "?lmt=1").then(resp => {
                    if (resp) {
                        // 初始 - 代理商编辑时，选择推荐代理商，不包含当前编辑的服务商ID。
                        this.arch_allAgentIdNameWithOutThis = deepClone(resp.data);
                        let idx = findIdxByKeyValue(this.arch_allAgentIdNameWithOutThis, 'code', this.insDevAllotOrderForm.inAgentCode);
                        if(idx) this.arch_allAgentIdNameWithOutThis.splice(idx,1);
                    }
                });
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initDevAllotOrders();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initDevAllotOrders();
            },
            viewAdd(snTexts) {
                this.titleDlg = '调拨出库';
                this.getAllotOrderNo();
                Object.assign(this.insDevAllotOrderForm, this.initDevAllotOrderForm);
                if(snTexts) this.insDevAllotOrderForm.termSnTxt = snTexts
                this.showDlg = true;
            },
            getAllotOrderNo() {
                this.getRequest(URL_DATA_ALLOTORDERNO).then(resp => { if (resp) this.insDevAllotOrderForm.allotBatNo = resp.obj.no });
            },
            getAgentName() {
                if(this.insDevAllotOrderForm.inAgentCode) this.getRequest(URL_AGENT_NAME+"?agentCode="+this.insDevAllotOrderForm.inAgentCode).then(resp => {
                    if (resp) {
                        this.insDevAllotOrderForm.inAgentName = resp.obj.name;
                        this.insDevAllotOrderForm.inAgentId = resp.obj.id;
                    }
                });
            },
            getAgentName2() {
                this.arch_allAgentIdNameWithOutThis.forEach(item => {
                    if (item.id === this.insDevAllotOrderForm.inAgentId) {
                        this.insDevAllotOrderForm.inAgentCode = item.code
                        this.insDevAllotOrderForm.inAgentName = item.name
                    }
                })
            },
            dlgCommit() {
                this.insertDevAllot();
            },
            insertDevAllot() {

                if(this.devObj) {
                    this.insDevAllotOrderForm.devAllotDetails = [];
                    for(let i=0;i<this.devObj.total;i++) {
                        this.insDevAllotOrderForm.devAllotDetails.push({'terSn':this.devObj.tsnLst[i]});
                    }

                    this.$refs['insDevAllotOrderForm'].validate(valid => {
                        if (valid) {

                            this.$confirm('调拨出库数量：' + this.devCnt + '台', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.postRequest("/dev/addDevAllotOrder", this.insDevAllotOrderForm).then(resp => {
                                    if (resp) {
                                        this.initDevAllotOrders();
                                        this.showDlg = false;
                                    }
                                });
                            }).catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: '已取消'
                                });
                            });

                        }
                    });
                }
                else {
                    this.$message({
                        type: 'info',
                        message: '序列号格式错'
                    });
                }
            },
            handleSelectionChange(val) {
            }
        }

    }
</script>

<style scoped>
</style>
